<template>
<v-hover
    v-slot:default="{ hover }"
    open-delay="50"
>
<v-card :elevation="hover ? 16 : 4">
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col align="center" justify="center" cols="12" xl="2" lg="2" md="12" sm="12">
                <v-img
                    v-bind:src="application.img_path"
                    width="150px"
                    alt="Placeholder image"
                    style="cursor: pointer;"
                ></v-img>                
            </v-col>
            <v-col align="center" justify="center" cols="12" xl="6" lg="6" md="12" sm="12">
                <v-row>
                    <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                        <p class="text-center">{{$t('loan_sum')}}</p>
                        <p class="text-center font-weight-bold title">{{application.sum}} {{$t('currency')}}</p>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                        <p class="text-center">{{$t('percentage_rate')}}</p>
                        <p class="text-center font-weight-bold title">{{application.bet}} %</p>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                        <p class="text-center">{{$t('payout_date')}}</p>
                        <p class="text-center font-weight-bold title">{{application.payout_date_show}}</p>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="6" sm="6">
                        <p class="text-center">{{$t('maturity_date')}}</p>
                        <p class="text-center font-weight-bold title">{{application.maturity_date_show}}</p>
                    </v-col>
                </v-row>
            </v-col>
            <v-col align="center" justify="center" cols="12" xl="2" lg="2" md="12" sm="12">
                <v-row>
                    <v-col cols="12">
                        <p class="text-center">{{$t('status')}}</p>
                        <p class="text-center font-weight-bold title">{{ application.status_show }}</p>
                    </v-col>
                </v-row>                
            </v-col>
            <v-col align="center" justify="center" cols="12" xl="2" lg="2" md="12" sm="12">
                <v-btn
                    color="primary"
                    :disabled="!application.button_show"
                    @click="changeApplication()"
                >
                    {{$t('correct_data')}}            
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</v-card>
</v-hover>
</template>

<script>
import moment from 'moment';
export default {
    name: 'Application',
    props: [
        'application'
    ],
    data() {
        return {
        };
    },
    methods: {
        changeApplication() {
            const application = {
                id: this.application.id,
                sum: this.application.sum,
                bet: this.application.bet,
                payout_date: moment(this.application.payout_date).format('YYYY-MM-DD'),
                maturity_date: moment(this.application.maturity_date).format('YYYY-MM-DD'),
            }
            this.$store.dispatch('CHANGE_APPLICATION_MODAL_DATA', application);
            this.$store.dispatch('OPEN_APPLICATION_MODAL', true);
        }
    }  
}
</script>

<style>
</style>